"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var luxon_1 = require("luxon");
var CalendarPicker_1 = __importDefault(require("../CalendarPicker"));
var icons_1 = require("../../icons");
var Input_1 = require("./Input");
var layout_1 = require("../../util/layout");
var colors_1 = require("../../util/colors");
var PickerWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .picker {\n    margin-top: 4px;\n\n    button,\n    abbr {\n      font-size: 14px;\n    }\n  }\n\n  .mobile-picker {\n    position: absolute;\n    top: 0;\n    left: -", "px;\n    right: -", "px;\n    width: 100vw;\n\n    .react-calendar__tile,\n    .react-calendar__navigation__arrow {\n      height: 2.5rem;\n      width: 2.5rem;\n    }\n  }\n"], ["\n  .picker {\n    margin-top: 4px;\n\n    button,\n    abbr {\n      font-size: 14px;\n    }\n  }\n\n  .mobile-picker {\n    position: absolute;\n    top: 0;\n    left: -", "px;\n    right: -", "px;\n    width: 100vw;\n\n    .react-calendar__tile,\n    .react-calendar__navigation__arrow {\n      height: 2.5rem;\n      width: 2.5rem;\n    }\n  }\n"])), function (_a) {
    var inputLeftPx = _a.inputLeftPx;
    return inputLeftPx;
}, function (_a) {
    var inputRightPx = _a.inputRightPx;
    return inputRightPx;
});
var CalendarIcon = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  pointer-events: none;\n  position: absolute;\n  left: 5px;\n  top: 7px;\n"], ["\n  pointer-events: none;\n  position: absolute;\n  left: 5px;\n  top: 7px;\n"])));
var DatePicker = function (_a) {
    var _b = _a.styledProps, styledProps = _b === void 0 ? {} : _b, onDateChange = _a.onDateChange, _c = _a.pickerProps, pickerProps = _c === void 0 ? {} : _c, nativeProps = __rest(_a, ["styledProps", "onDateChange", "pickerProps"]);
    var defaultValue = nativeProps.defaultValue, onChange = nativeProps.onChange, rest = __rest(nativeProps, ["defaultValue", "onChange"]);
    var _d = (0, react_1.useState)(defaultValue ? luxon_1.DateTime.fromISO(defaultValue) : null), value = _d[0], setValue = _d[1];
    var _e = (0, react_1.useState)(false), pickerVisible = _e[0], setPickerVisible = _e[1];
    var mobileViewport = (0, layout_1.isMobileViewport)();
    var inputRef = (0, react_1.useRef)(null);
    var dateChanged = function (newDate) {
        var newDateLuxon = typeof newDate === 'string'
            ? luxon_1.DateTime.fromISO(newDate)
            : // TODO: update this when implementing date range picking
                Array.isArray(newDate)
                    ? null
                    : luxon_1.DateTime.fromISO(newDate.toISOString());
        if (newDateLuxon.invalidExplanation) {
            console.error(newDateLuxon.invalidExplanation);
        }
        else {
            setValue(newDateLuxon);
            setPickerVisible(false);
            onDateChange && onDateChange(newDateLuxon);
        }
    };
    var minDate = pickerProps.minDate, maxDate = pickerProps.maxDate, disabledDow = pickerProps.disabledDow, disabledDates = pickerProps.disabledDates;
    return (react_1.default.createElement(Input_1.InputStyle, __assign({}, styledProps, { style: { position: 'relative' }, ref: inputRef }),
        react_1.default.createElement("input", __assign({ style: { paddingLeft: '2rem', cursor: 'pointer' }, onFocus: function (_) { return setPickerVisible(true); }, onClick: function (_) { return setPickerVisible(true); } }, rest, { onChange: function (e) { return dateChanged(e.target.value); }, readOnly: true, value: value ? value.toFormat('ccc LLL d') : '', placeholder: "Select a date" })),
        react_1.default.createElement(CalendarIcon, { style: { pointerEvents: 'none' } },
            react_1.default.createElement(icons_1.Calendar, { color: colors_1.colors.gray800 })),
        pickerVisible && inputRef.current && (react_1.default.createElement(PickerWrapper, { inputLeftPx: inputRef.current.offsetLeft, inputRightPx: inputRef.current.offsetLeft + inputRef.current.offsetWidth },
            react_1.default.createElement(CalendarPicker_1.default, { pickerClassName: mobileViewport ? 'picker mobile-picker' : 'picker', minDetail: "month", defaultValue: value ? new Date(value.valueOf()) : null, minDate: minDate ? new Date(minDate.valueOf()) : null, maxDate: maxDate ? new Date(maxDate.valueOf()) : null, onChange: dateChanged, onDismiss: function () { return setPickerVisible(false); }, tileDisabled: disabledDow || disabledDates
                    ? function (_a) {
                        var view = _a.view, date = _a.date;
                        return view === 'month' &&
                            ((disabledDow &&
                                disabledDow.includes(date.getDay())) ||
                                (disabledDates &&
                                    disabledDates.some(function (d) { return d === date.toISOString().substring(0, 10); })));
                    }
                    : undefined })))));
};
exports.DatePicker = DatePicker;
var templateObject_1, templateObject_2;
//# sourceMappingURL=DatePicker.js.map